export const orderStatus = {
    10: '주문완료',
    20: '결제완료',
    30: '배송준비',
    40: '결제완료',
    50: '결제완료',
    60: '결제완료',
    100: '결제완료',
    110: '결제완료',
    120: '결제완료',
};

export const refundStatus = {
    // 1: '대기',
    2: '불가',
    3: '완료',
}

export const storeType = {
    1: '앱스토어',
    2: '플레이스토어'
}
